// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqQuoteDetailsPageStyles } from "@eisinc/Overrides/Pages/RfqQuoteDetailsPage";
import { css } from "styled-components";


rfqQuoteDetailsPageStyles.spinnerWrapper = {
    css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            height: 300px;
        `,
};
rfqQuoteDetailsPageStyles.headerGridItem = {
    width: 12,
};
rfqQuoteDetailsPageStyles.infoGridItem = {
    width: 12,
};
rfqQuoteDetailsPageStyles.quoteLinesGridItem = {
    width: 12,
};
rfqQuoteDetailsPageStyles.contentOneGridItem = {
    width: [12, 12, 12, 6, 6],
    printWidth: 12,
};

rfqQuoteDetailsPageStyles.contentTwoGridItem = {
    width: [12, 12, 12, 3, 3],
    printWidth: 12,
};
rfqQuoteDetailsPageStyles.repInfoGridItem = {
    width: [12, 12, 6, 12, 12],
};
rfqQuoteDetailsPageStyles.notesGridItem = {
    width: [12, 12, 12, 12, 12],
};
rfqQuoteDetailsPageStyles.linesGridItem = {
    width: [12, 12, 12, 12, 12],
    printWidth: 12,
};